import React from 'react';

interface FormInputProps {
  label: string;
  name: string;
  type?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  error?: string;
}

const FormInput = ({
  label,
  name,
  type = 'text',
  placeholder,
  value,
  onChange,
  required = false,
  error,
}: FormInputProps) => {
  return (
    <div data-component-id="src/app/quote-request/components/FormInput.tsx:25:4" data-component-path="src/app/quote-request/components/FormInput.tsx" data-component-line="25" data-component-end-line="43" data-component-file="FormInput.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-2%22%7D" className="space-y-2">
      <label data-component-id="src/app/quote-request/components/FormInput.tsx:26:6" data-component-path="src/app/quote-request/components/FormInput.tsx" data-component-line="26" data-component-end-line="29" data-component-file="FormInput.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22block%20text-sm%20font-body%20font-medium%20text-foreground%22%7D" htmlFor={name} className="block text-sm font-body font-medium text-foreground">
        {label}
        {required && <span data-component-id="src/app/quote-request/components/FormInput.tsx:28:21" data-component-path="src/app/quote-request/components/FormInput.tsx" data-component-line="28" data-component-end-line="28" data-component-file="FormInput.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-error%20ml-1%22%2C%22textContent%22%3A%22*%22%7D" className="text-error ml-1">*</span>}
      </label>
      <input data-component-id="src/app/quote-request/components/FormInput.tsx:30:6" data-component-path="src/app/quote-request/components/FormInput.tsx" data-component-line="30" data-component-end-line="41" data-component-file="FormInput.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22id%22%3A%22%5Bvar%3Aname%5D%22%2C%22name%22%3A%22%5Bvar%3Aname%5D%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%7D"
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`w-full px-4 py-3 rounded-lg border-2 font-body text-foreground placeholder:text-muted-foreground transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/20 ${
          error ? 'border-error' : 'border-input focus:border-primary'
        }`}
      />
      {error && <p data-component-id="src/app/quote-request/components/FormInput.tsx:42:16" data-component-path="src/app/quote-request/components/FormInput.tsx" data-component-line="42" data-component-end-line="42" data-component-file="FormInput.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-error%20font-body%22%7D" className="text-sm text-error font-body">{error}</p>}
    </div>
  );
};

export default FormInput;